import RoleAccessLayout from '../roles/role_access_layout.jsx';

const RoleAccessPage = () => {
  return (
      <RoleAccessLayout />
  );
};

export default RoleAccessPage;